module.exports = __webpack_public_path__ + "img/past_dates.d41d8cd9.svg";